import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import { logoutUser } from "../actions/user";

import Loading from "../components/Loading";

const mapDispatchToProps = (dispatch) => ({
  logoutUser: () => dispatch(logoutUser()),
});

class Logout extends React.Component {
  state = {
    loggedOut: false,
  };

  componentDidMount() {
    const { logoutUser } = this.props;
    logoutUser().then(() => this.setState({ loggedOut: true }));
  }

  render() {
    const { loggedOut } = this.state;
    return loggedOut ? <Redirect to="/" /> : <Loading fullPage />;
  }
}

Logout.propTypes = {
  logoutUser: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(Logout);
